























import { IResultPage } from '@app/componentlib/src/common/types/JobMatchTypes'
import { IJobPosting } from '@app/componentlib/src/common/types/JobSearchTypes'
import { AppModule } from '@app/componentlib/src/store/modules/app'
import { JobMatchModule } from '@app/componentlib/src/store/modules/JobMatch/jobMatch'

import Vue from 'vue'
import Component from 'vue-class-component'

@Component<MobileButtonBottom>({
  props: {
    selectedJobPosting: Object,
    mobileFilterIsActive: Boolean,
    content: Object,
    iconOnJumpToStepButton: Object,
    jobmatch: Boolean,
    jobApplicationAccess: Boolean
  }
})

export default class MobileButtonBottom extends Vue {
  /**
   * Props variables
   */
  selectedJobPosting: IJobPosting | undefined
  mobileFilterIsActive: Boolean = false
  content: IResultPage | undefined
  iconOnJumpToStepButton: string = ''
  jobmatch: boolean = false
  jobApplicationAccess: boolean | undefined

  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */


  /**
   * Getters
   */
  get t (): any {
    return AppModule.translations
  }

  /**
   * Methods
   */
  goToPage (url: string) {
    if (url !== null && url !== "" && url !== undefined) {
      window.open(url, '_blank', 'noopener,noreferrer')?.focus()
    }
  }

  goToJobApplication (jobId?: string) {
    if (this.content && jobId !== undefined) {
      const req = {
        url: this.content.navigateToJobApplication,
        jobId: jobId
      }
      JobMatchModule.navigateToJobApplication(req)
    }
  }

}
